import { CLOSE_CONTACT_US_MODAL, OPEN_CONTACT_US_MODAL } from './types';

export const openContactUsModal = () => ({ type: OPEN_CONTACT_US_MODAL });
export const closeContactUsModal = () => ({ type: CLOSE_CONTACT_US_MODAL });
